import { USER_ROLES } from '@hygge/shared';

/**
 * The system roles the Add Employee / Hire form may offer. Only a super_admin
 * may give an account the super_admin role — the server answers 403 to anyone
 * else — so the option is not listed for them. Kept out of the component for
 * the node vitest (see profile-tabs.ts). [HW-1061]
 */
export function assignableRoles<T extends { name: string }>(
  roles: T[],
  isSuperAdmin: boolean
): T[] {
  return isSuperAdmin ? roles : roles.filter((role) => role.name !== USER_ROLES.SUPER_ADMIN);
}
